
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['navLocalePath', 'navType', 'navName', 'imageType'],
  emits: ['hide-navigation'],
  setup(props, { emit }) {
    let imageSuffix = props.imageType
    if (!props.imageType) {
      imageSuffix = 'jpg'
    }

    const hideNavi = () => {
      emit('hide-navigation', '')
    }
    return { imageSuffix, hideNavi }
  },
})
